import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBezier"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V9H5.25V15H3V21H8.75V18.75H15V21H21V15H18.75V9H21V3H15V5.25H9V3H3ZM9 9V6.75H15V9H17.25V15H15V17.25H8.75V15H6.75V9H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezier;
